import { render, staticRenderFns } from "./WelcomeModal.html?vue&type=template&id=ad5c5b3e&scoped=true&"
import script from "./WelcomeModal.vue?vue&type=script&lang=js&"
export * from "./WelcomeModal.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeModal.scss?vue&type=style&index=0&id=ad5c5b3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5c5b3e",
  null
  
)

export default component.exports